import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { ContainerRow } from "@/lib/api";
import { cn } from "@/lib/utils";
import { EllipsisVertical, Link2, Share2 } from "lucide-react";

// A Boo's ⋮ menu on the diagram's cards and the list's rows. Clicks stay inside
// it: the card or row opens the Boo on any click that reaches it, and React
// bubbles portal clicks up to it too.
export function BooMenu({
  boo,
  onLink,
  onOpenSharing,
  className,
}: {
  boo: ContainerRow;
  onLink?: (boo: ContainerRow) => void;
  onOpenSharing?: (boo: ContainerRow) => void;
  className?: string;
}) {
  if (!onLink && !onOpenSharing) return null;
  const canLink = boo._permissions?.canLink === true;
  const canView = boo._permissions?.canView === true;
  const stop = (e: React.SyntheticEvent) => e.stopPropagation();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        onClick={stop}
        aria-label={`${boo.name} menu`}
        className={cn(
          "relative -mr-1.5 flex size-8 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground data-[state=open]:bg-muted data-[state=open]:text-foreground",
          className,
        )}
      >
        <EllipsisVertical className="size-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60" onClick={stop}>
        {onLink && (
          <DropdownMenuItem disabled={!canLink} onSelect={() => onLink(boo)}>
            <Link2 />
            Learn from another Boo
          </DropdownMenuItem>
        )}
        {onOpenSharing && (
          <DropdownMenuItem disabled={!canView} onSelect={() => onOpenSharing(boo)}>
            <Share2 />
            Sharing settings
          </DropdownMenuItem>
        )}
        {onLink && !canLink && (
          <p className="px-1.5 pt-1 pb-0.5 text-xs text-muted-foreground text-pretty">
            Only {boo.name}&apos;s admins can link it to other Boos.
          </p>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
